import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=8e6fc77c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=8e6fc77c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6fc77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e6fc77c')) {
      api.createRecord('8e6fc77c', component.options)
    } else {
      api.reload('8e6fc77c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=8e6fc77c&scoped=true&", function () {
      api.rerender('8e6fc77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZSo8JW46iUPa/JS/teamMember.vue"
export default component.exports